module.exports = __webpack_public_path__ + "img/sparking-change-envision.7f2505f3.png";